import styled from 'styled-components';

export const AgGridTablePageContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: fit-content;
`;
